import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled from '@emotion/styled';
// Lucide React 직접 import - Vite 번들링 최적화 및 초기화 순서 문제 해결
import { CheckCircle2 } from 'lucide-react';
import { Target } from 'lucide-react';
const Container = styled.div`
  background: linear-gradient(135deg, 
    var(--vscode-editor-selectionBackground, rgba(33, 150, 243, 0.1)) 0%, 
    var(--vscode-editor-selectionHighlightBackground, rgba(33, 150, 243, 0.05)) 100%
  );
  border: 1px solid var(--vscode-editor-selectionHighlightBorder, rgba(33, 150, 243, 0.3));
  border-radius: var(--theme-radius-md, 8px);
  padding: var(--theme-spacing-lg, 24px);
  margin: var(--theme-spacing-lg, 24px) 0;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 4px;
    height: 100%;
    background: var(--vscode-textLink-foreground, var(--theme-primary, #2196F3));
  }
`;
const Title = styled.h3`
  color: var(--vscode-editor-foreground, var(--theme-text));
  margin: 0 0 var(--theme-spacing-md, 16px) 0;
  font-size: var(--theme-typography-font-size-lg, 1.125rem);
  font-weight: var(--theme-typography-font-weight-semibold, 600);
  display: flex;
  align-items: center;
  gap: var(--theme-spacing-sm, 8px);

  svg {
    color: var(--vscode-textLink-foreground, var(--theme-primary, #2196F3));
  }
`;
const ObjectivesList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;
const Objective = styled.li`
  display: flex;
  align-items: flex-start;
  gap: var(--theme-spacing-sm, 8px);
  margin-bottom: var(--theme-spacing-sm, 8px);
  color: var(--vscode-editor-foreground, var(--theme-text));
  font-size: var(--vscode-font-size, var(--theme-typography-font-size-sm, 0.875rem));
  line-height: 1.6;
  
  &:last-child {
    margin-bottom: 0;
  }
  
  svg {
    flex-shrink: 0;
    margin-top: 2px;
    color: var(--vscode-testing-iconPassed, var(--theme-success, #4CAF50));
  }
`;
const LearningObjectives = ({ objectives })=>{
    let parsedObjectives = [];
    try {
        parsedObjectives = JSON.parse(objectives);
    } catch (e) {
        console.error("Failed to parse objectives:", e);
        return null;
    }
    if (parsedObjectives.length === 0) return null;
    return /*#__PURE__*/ _jsxs(Container, {
        children: [
            /*#__PURE__*/ _jsxs(Title, {
                children: [
                    /*#__PURE__*/ _jsx(Target, {
                        size: 20
                    }),
                    "학습 목표"
                ]
            }),
            /*#__PURE__*/ _jsx(ObjectivesList, {
                children: parsedObjectives.map((objective, index)=>/*#__PURE__*/ _jsxs(Objective, {
                        children: [
                            /*#__PURE__*/ _jsx(CheckCircle2, {
                                size: 16
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                children: objective
                            })
                        ]
                    }, index))
            })
        ]
    });
};
// Default export for backward compatibility
export default LearningObjectives;
